/* istanbul ignore file */

import CreateContractRequestForm from 'domain/sales/opportunity/presale/contract/form/CreateContractRequestForm';
import UpdateContractRequestForm from 'domain/sales/opportunity/presale/contract/form/UpdateContractRequestForm';
import ContractOutputTimelineRecordLayout from 'domain/sales/opportunity/presale/contract/ContractOutputTimelineRecordLayout';
import { CREATE_CONTRACT_REQUEST, PRESALE_ITEMS_TYPE } from 'domain/sales/opportunity/opportunityService';
import type { Data } from 'framework/types';
import { TimelineItem } from 'framework/ui/timeline';

const useContractRequestItem = () => ({
  AddForm: CreateContractRequestForm,
  UpdateForm: UpdateContractRequestForm,
  isApplicable: (item: any) => item?.contractRequest,
  source: 'contractRequest',
  urlPostfix: PRESALE_ITEMS_TYPE.CONTRACT_REQUEST,
  RecordLayout: ContractOutputTimelineRecordLayout,
  name: 'Contract Request',
  permissionToCheck: CREATE_CONTRACT_REQUEST,
  additionalAfterAddSubmit: (item: TimelineItem, parentContext?: Data) => {
    const oppState = parentContext?.getValueBySource('stateStep');
    if (oppState === 'PROPOSAL') {
      window.location.reload(); // reload page for fetch actual state
    }
  },
});

export default useContractRequestItem;
